import { getAxios } from '../axios';
import {
  addParam,
  errorCatch,
  getNotificationId,
  getTokenHeaders
} from '../helper';
import {
  ENDPOINT_LOCAL_KIOSK_SETTINGS,
} from '../../config/endpoints';
import { Messages } from '../../config';
import { store } from '../../store/store';
import { displayNotification } from '../../store/actions/notification';
import { NOTIFICATION_SUCCESS } from '../../store/actions/types';

/**
 * Update Local Kiosk setting for an organization.
 *
 * @param {object} payload
 * @param {string} payload.organizationId
 * @param {object} payload.data
 * @param {number} payload.data.status
 * @param {string} [payload.notificationId]
 * @returns {Promise<T>}
 */
export function updateOrganizationKioskAccess(payload) {
  return getAxios().put(
    addParam(
      ENDPOINT_LOCAL_KIOSK_SETTINGS,
      {
        '{organization}': payload.organizationId,
      }
    ),
    payload.data,
    getTokenHeaders()
  )
    .then(response => {
      if (response && response.data) {
        store.dispatch(
          displayNotification(
            NOTIFICATION_SUCCESS,
            Messages.UPDATE_RESOURCE_SUCCESS,
            payload.notificationId
          )
        );

        return response.data;
      }

      return null;
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload));

        return e.response;
      }
    );
}
